import { useMemo } from 'react';

import { NamePath } from '~/utils/buildNamePath';
import { isAgent } from '~/utils/getDecodedJwt';
import { useFormItemContext } from './FormItemContext';

export const useSoftDeclineItemContext = (name: NamePath | undefined | any) => {
  const formItemContext = useFormItemContext();

  const nameString = useMemo(() => {
    return [name].flat().join('.').replace('.[]', '[]');
  }, [name]);

  const warningObject = useMemo(() => {
    const warningObj = formItemContext.errorFields?.find(
      (item) =>
        nameString &&
        item.key?.includes(nameString) &&
        (item.type === 'WARN' || item.type === 'CHECKED')
    );
    if (!warningObj) return undefined;
    return warningObj;
  }, [nameString, formItemContext.errorFields]);

  const itemWithWarningMessage = warningObject?.type === 'WARN';
  const itemWithCheckedMessage = warningObject?.type === 'CHECKED';
  const isResubmit = !!formItemContext.errorFields && formItemContext?.errorFields?.length > 0;
  // if there is any field to fix on resubmit, then all fields on this step should be editable
  const isFormWithErrorFields = !!formItemContext?.errorFields?.find(({ key }) =>
    key.startsWith(nameString.split('.')?.[0])
  );
  const isItemNotEditable =
    isResubmit && !isFormWithErrorFields && !itemWithWarningMessage && !isAgent();
  const isItemEditableBySoftDecline = itemWithWarningMessage || itemWithCheckedMessage;
  const isValueUpdated = false;

  return {
    warningMessage: warningObject?.description,
    isValueUpdated,
    withWarning: itemWithWarningMessage && !isValueUpdated,
    disabled: isItemNotEditable,
    editableBySoftDecline: isItemEditableBySoftDecline,
  };
};
